import { Grid } from "../ui";
import type { CSSProperties, ReactNode } from "react";
import { spacing } from "../settings/settingsListDesign";

export type ResponsiveFormGridProps = {
  columns?: 1 | 2 | 3 | 4;
  minDesktopColumnWidth?: number;
  gap?: number;
  children: ReactNode;
};

/** Established form grid: desktop columns, one column below the member breakpoint. */
export function ResponsiveFormGrid({ columns = 2, minDesktopColumnWidth = 260, gap = spacing.md, children }: ResponsiveFormGridProps) {
  const screens = Grid.useBreakpoint();
  const desktop = screens.md !== false;
  return <div className="mu-responsive-form-grid" style={{
    "--mu-responsive-form-grid-min-width": `${minDesktopColumnWidth}px`,
    display: "grid", gridTemplateColumns: desktop ? `repeat(${columns}, minmax(0, 1fr))` : "minmax(0, 1fr)", gap,
  } as CSSProperties}>{children}</div>;
}
